import { DakokuDataFull, DakokuInfoShinsei, DakokuInfoShinseiForSoumuSyuusei } from "@/types/Dakoku";
import { useInit } from "@/composable/kinmu/soumu-syuusei/init"
import dayjs from "dayjs";
import { onMounted, reactive, ref, Ref } from "vue";

export function useSoumuSyuuseiModal() {

  const soumuSyuuseiModalRef = ref();

  const { initSyuuseiData } = useInit(null)

  const syuuseiData = reactive(initSyuuseiData())

  const setData = async (syuuseiTarget: DakokuDataFull | null, datetime: string, userId: number, shinseis: DakokuInfoShinsei | null) => {
    if (syuuseiTarget) {
      syuuseiData.before = syuuseiTarget
      syuuseiData.after.syukkin_time = syuuseiTarget.syukkin_datetime ? datetimeTypeFormat(syuuseiTarget.syukkin_datetime) : null
      syuuseiData.after.taikin_time = syuuseiTarget.taikin_datetime ? datetimeTypeFormat(syuuseiTarget.taikin_datetime) : null
      syuuseiData.after.gaisyutsu_time = syuuseiTarget.taikin_datetime ? datetimeTypeFormat(syuuseiTarget.gaisyutsu_datetime) : null
      syuuseiData.after.modori_time = syuuseiTarget.modori_datetime ? datetimeTypeFormat(syuuseiTarget.modori_datetime) : null
      syuuseiData.after.kyuukei_time = syuuseiTarget.kyuukei_times ?? null
      syuuseiData.after.syotei_work_times = syuuseiTarget.syotei_work_times ?? null
      syuuseiData.after.koujo_times = syuuseiTarget.koujo_times ?? null
      syuuseiData.after.houteinai_zangyou_times = syuuseiTarget.houteinai_zangyou_times ?? null
      syuuseiData.after.jikangai_work_times = syuuseiTarget.jikangai_work_times ?? null
      syuuseiData.after.shinya_warimashi_times = syuuseiTarget.shinya_warimashi_times ?? null
      syuuseiData.after.chikoku_times = syuuseiTarget.chikoku_times ?? null
      syuuseiData.after.soutai_times = syuuseiTarget.soutai_times ?? null

      // 本当はAPI取得段階でインターフェイスを分けておくべきなんだろうけど影響範囲が大きいので
      // ここでDakokuInfoShinseiをDakokuInfoShinseiForSoumuSyuuseiと扱うよう変換する
      // DakokuInfoShinseiForSoumuSyuuseiはDakokuInfoShinseiをextendsしてfurideを追加しただけのもの
      // 総務修正ダイアログでfurikyuuの中身をfurikyuuとfurideに再振り分けするため用意している（furikyuuという名前だが「振休・振出」をまとめたもので振出も扱っている）
      // もともと総務修正ダイアログでは振休と振出を同時に扱えなかったのでfurideは不要だったがMEDICA_AS-1202対応により同時に扱うよう変更となったため
      const shinseisForSoumuSyuusei = shinseis as DakokuInfoShinseiForSoumuSyuusei
      shinseisForSoumuSyuusei.furide = []
      syuuseiData.shinseis = shinseisForSoumuSyuusei
    } else {
      syuuseiData.after = initSyuuseiData().after
      syuuseiData.before = initSyuuseiData().before
      syuuseiData.shinseis = null
    }

    syuuseiData.before.dakoku_date = syuuseiData.after.dakoku_date = datetime
    syuuseiData.before.user_id = syuuseiData.after.user_id = userId
  }


  const clearData = async () => {
    syuuseiData.after = initSyuuseiData().after
    syuuseiData.before = initSyuuseiData().before
  }

  const soumuSyuuseiModalParts = reactive({
    title: '総務修正',
    button: ''
  })

  const openSoumuSyuuseilModal = () => {
    soumuSyuuseiModalRef.value.open()
  }

  const closeSoumuSyuuseilModal = () => {
    soumuSyuuseiModalRef.value.close()
  }

  const datetimeTypeFormat = (datetime: string | Date | null, format: string = 'HH:mm') => {
    if (!datetime) {
      return null
    }
    return dayjs(datetime).format(format)
  }

  return {
    soumuSyuuseiModalRef,
    soumuSyuuseiModalParts,
    openSoumuSyuuseilModal,
    closeSoumuSyuuseilModal,
    syuuseiData,
    setData,
    clearData
  }
}
